// 目标类型
import http from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 分页查询-xsh
export function getTypeReportList(data) {
    return http({
        url: apiCrmHost + '/goal/manage/goalType/page',
        method: 'post',
        data
    });
};
// 保存-xsh
export function saveTypeReportList(data) {
    return http({
        url: apiCrmHost + '/goal/manage/goalType/save',
        method: 'post',
        data
    });
};
// 导出-xsh
export function exportTypeReportList(data) {
    return http({
        url: apiCrmHost + '/goal/manage/goalType/export',
        method: 'post',
        data
    });
};
